module.exports = __webpack_public_path__ + "img/ig.8f43c605.svg";